(function () {
  const PROMO_PARAM_KEY = "promo";
  const UTM_PARAM_KEY = "utm_source";
  const UTM_CAMPAIGN_KEY = "utm_campaign";
  const AIC_KEY = "aic";
  const REFERRAL_VALUE = "referral";
  const RESET_PARAM_KEY = "reset_storage";
  const NIFT_PATH_PREFIX = "/pages/nift";
  const QUIZ_PATH_PREFIX = "/pages/dog-quiz";
  const NIFT_DISCOUNT_CODE = "NIFT55";
  const QUIZ_DISCOUNT_PARAM = "discount";
  const PROMO_APPLIED_FLAG = "promo_discount_applied";

  const PROMO_STORAGE_KEY = "promo";
  const NIFT_DISCOUNT_STORAGE_KEY = "promo";

  const params = new URLSearchParams(window.location.search);
  const pathname = (window.location.pathname || "").toLowerCase();

  if (params.get(RESET_PARAM_KEY) === "true") {
    try {
      if (typeof localStorage !== "undefined") {
        localStorage.removeItem(PROMO_STORAGE_KEY);
        localStorage.removeItem(NIFT_DISCOUNT_STORAGE_KEY);
      }
    } catch (e) {
      // Ignore storage issues (e.g. blocked or unavailable).
    }
    return;
  }

  function getReferralPromoValue() {
    const utmCampaign = params.get(UTM_CAMPAIGN_KEY);
    if (utmCampaign) {
      const match = utmCampaign.match(/_(\d+)$/);
      return match ? match[1] : utmCampaign;
    }

    const aic = params.get(AIC_KEY);
    if (aic) return aic;

    return null;
  }

  function storePromoTemporarily(value, code) {
    try {
      if (typeof localStorage !== "undefined") {
        localStorage.setItem(
          PROMO_STORAGE_KEY,
          JSON.stringify({
            value,
            code: code || null,
            timestamp: Date.now()
          })
        );
      }
    } catch (e) {
      // Ignore storage failures – promo is a nice-to-have.
    }
  }

  function storeNiftDiscount() {
    storePromoTemporarily(NIFT_DISCOUNT_CODE, NIFT_DISCOUNT_CODE);
  }

  function getStoredPromo() {
    try {
      if (typeof localStorage === "undefined") return null;

      const raw = localStorage.getItem(NIFT_DISCOUNT_STORAGE_KEY);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      return parsed && parsed.value ? parsed : null;
    } catch {
      return null;
    }
  }

  let resolvedPromo = null;

  if (params.has(PROMO_PARAM_KEY)) {
    resolvedPromo = params.get(PROMO_PARAM_KEY);
  }
  else if (params.get(UTM_PARAM_KEY) === REFERRAL_VALUE) {
    resolvedPromo = getReferralPromoValue();
  }

  if (pathname.startsWith(NIFT_PATH_PREFIX)) {
    storeNiftDiscount();
  }

  if (resolvedPromo) {
    storePromoTemporarily(resolvedPromo);
  }

  if (pathname.startsWith(QUIZ_PATH_PREFIX)) {
    const promo = getStoredPromo();
    if (promo && promo.code && !window.globalDiscountCode) {
      window.globalDiscountCode = promo.code;
    }

    let hasDiscountParam = false;
    let alreadyApplied = false;

    try {
      hasDiscountParam = params.has(QUIZ_DISCOUNT_PARAM);
      alreadyApplied =
        typeof sessionStorage !== "undefined" &&
        sessionStorage.getItem(PROMO_APPLIED_FLAG) === "true";
    } catch (e) {
      hasDiscountParam = params.has(QUIZ_DISCOUNT_PARAM);
      alreadyApplied = false;
    }

    if (promo && promo.code && !hasDiscountParam && !alreadyApplied) {
      try {
        if (typeof sessionStorage !== "undefined") {
          sessionStorage.setItem(PROMO_APPLIED_FLAG, "true");
        }
      } catch (e) {
        // Ignore session storage failures.
      }

      const url = new URL(window.location.href);
      url.searchParams.set(QUIZ_DISCOUNT_PARAM, promo.code);
      window.location.replace(url.toString());
    }
  }
})();

(function () {
  const PROMO_MESSAGES = {
    "116005": "GET A FREE INTRO BOX",
    "121196": "Sizzle Society Exclusive - Claim Your Free Box",
    "121621": "January Offer - Claim Your Free Box",
    "122076": "Nift Exclusive - Claim Your Free Box",
    "NIFT55": "Nift Exclusive - 55% Off Your First Order",
    "free_liver_50": "50% Off Your First Order + Free Liver Bites",
  };

  async function getPromo() {
    try {
      if (typeof localStorage === "undefined") return null;

      const raw = localStorage.getItem("promo");
      if (!raw) return null;

      return JSON.parse(raw).value;
    } catch {
      return null;
    }
  }

  async function updateBar() {
    const promo = await getPromo();
    const discountCode = window.globalDiscountCode || null;
    const message = PROMO_MESSAGES[promo || ""] || PROMO_MESSAGES[discountCode || ""];

    if (!message) return;

    const el = document.querySelector(".announcement-bar__message");
    if (el) el.textContent = message;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateBar);
  } else {
    updateBar();
  }
})();
